import React from "react";
import { Link } from "react-router-dom";
import "./Front.css";
const Front = () => {
  return (
    <div className="landing-page">
      <img className="landing-page-bg" src="./images/bg.svg" />
      <div className="container landing-page-content">
        <div className="row">
          <div className="col-6 col-md-4 title">
            <h2>Thinking of Moving to Microsoft Azure </h2>
            <br />
            {/*<p>
              Over 80+ features bundled into one single solution to make your
              BizTalk Server monitoring and administration super efficient and
              secure.
            </p>*/}
            <Link to="/free-trial">
              <button className="btn btn-trial mt-2">Free 30-day Trial</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Front;
